import { render } from "./PhotoPage.vue?vue&type=template&id=78405cb7&ts=true"
import script from "./photo.components.ts?vue&type=script&lang=ts"
export * from "./photo.components.ts?vue&type=script&lang=ts"

import "./photo.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/richcle-kyc-fe/richcle-kyc-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__